import dayjs from 'dayjs'

export function getWalkinBookableSlot(todaysSlots) {
  const slots = (Array.isArray(todaysSlots) ? todaysSlots : [])
    .filter((slot) => slot?.startTime && slot?.endTime)
    .sort((a, b) => dayjs(a.startTime).valueOf() - dayjs(b.startTime).valueOf())
  if (slots.length === 0) return null

  const now = dayjs()
  const futureSlot = slots.find((slot) => dayjs(slot.startTime).valueOf() >= now.valueOf())
  if (futureSlot) return { ...futureSlot, immediate: false }

  const activeSlot = slots.find(
    (slot) =>
      dayjs(slot.startTime).valueOf() <= now.valueOf() &&
      dayjs(slot.endTime).valueOf() > now.valueOf(),
  )
  if (activeSlot) return { ...activeSlot, immediate: true }

  return null
}
